import {
  Grid,
  styled,
  Typography,
  useTheme
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../components/Icon";
import { CustomRegex } from "../../../utils/regex";
import { GridItemProps } from "../Password.types";

export type IPasswordRequirements = {
    isMobile: boolean;  
    newPassword: string;
}

export const PasswordRequirements = ({ isMobile, newPassword }: IPasswordRequirements) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      rowGap={ isMobile? 2 : 1.5 }
      width="100%"

      sx={ {
        "div": {
          "&:last-of-type" : {
            alignItems: "initial"
          }
        }

      } }
    >
      <Grid
        item
        xs={ 12 }
        component={ Typography }
        fontSize={ isMobile ? "0.75rem" : "0.875rem" }
        lineHeight={ isMobile ? "0.75rem" : "1.125rem" }
        marginTop={ isMobile ? "8px" : "0" }
      >
        { t("pw_criteria_text") }:
      </Grid>
      <GridItem
        xs={ 6 }
        fontSize={ isMobile ? "0.75rem" : "0.875rem" }
        lineHeight={ isMobile ? "0.75rem" : "1.125rem" }
        active={ CustomRegex.testLength(newPassword, 8) }
      >
        { t("pw_ch") }
      </GridItem>
      <GridItem
        xs={ 6 }
        fontSize={ isMobile ? "0.75rem" : "0.875rem" }
        lineHeight={ isMobile ? "0.75rem" : "1.125rem" }
        active={ CustomRegex.testUppercase(newPassword) }
      >
        { t("pw_cap_let") }
      </GridItem>
      <GridItem
        xs={ 6 }
        fontSize={ isMobile ? "0.75rem" : "0.875rem" }
        lineHeight={ isMobile ? "0.75rem" : "1.125rem" }
        active={ CustomRegex.testLowercase(newPassword) }
      >
        { t("pw_let") }
      </GridItem>
      <GridItem
        xs={ 6 }
        fontSize={ isMobile ? "0.75rem" : "0.875rem" }
        lineHeight={ isMobile ? "0.75rem" : "1.125rem" }
        active={ CustomRegex.testNumber(newPassword) }
      >
        { t("pw_num") }
      </GridItem>
      <GridItem
        xs={ 6 }
        fontSize={ isMobile ? "0.75rem" : "0.875rem" }
        lineHeight={ isMobile ? "0.75rem" : "1.125rem" }
        active={ CustomRegex.testSpecialCharacter(newPassword) }
      >
        { t("pw_special_ch") }
      </GridItem>
    </Grid>  

  );};


const StyledIcon = styled(Icon)(() => ({
  transform: "scale(1)"
}));

function GridItem({
  active=false,
  children,
  xs,
  fontSize
}: GridItemProps) {
  const theme = useTheme();

  return (
    <Grid
      item
      xs={ xs }
      wrap={ "nowrap" }
      container
      alignItems="center"
      gap={ 1 }
    >
      <StyledIcon
        color={ active ? theme.customColors.backgroundPrimaryCta : undefined }
        icon={ "Icons_modulo-completato" }
        size="1.25rem"
      />
      <Typography fontSize={ fontSize }>
        { children }
      </Typography>
    </Grid>
  );
}
